(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-special"] && !Shopify.designMode) return;
  try {
    
class CollectionSpecial extends HTMLElement {
  constructor() {
    super();

    this.color = this.dataset.colorHover || '#FFFFFF';
    this.selectorMedia = this.dataset.image;
    this.words = this.querySelectorAll('[data-text="hover"] span');

    this.initPage();

    console.log('WORDS: ', this.words);
  }

  initPage() {
    const items = this.querySelectorAll('.collection-special');

    items.forEach((item) => {
      const media = item.querySelector(this.selectorMedia);

      if (media) {
        item.addEventListener('mousemove', (event) => {
          const containerRect = item.getBoundingClientRect();
          const x = event.clientX - containerRect.left;
          const y = event.clientY - containerRect.top;
          media.style.left = `${x}px`;
          media.style.top = `${y}px`;
          this.updateTextColor(this.words, media);
        });

        item.addEventListener('mouseleave', () => {
          this.words.forEach((elemenWord) => {
            elemenWord.classList.remove('active');
            elemenWord.removeAttribute('style');
          })
        });
      }
    });
  }

  updateTextColor(elements, image) {
    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const imageRect = image.getBoundingClientRect();
      if (
        imageRect.left < rect.right &&
        imageRect.right > rect.left &&
        imageRect.top < rect.bottom &&
        imageRect.bottom > rect.top
      ) {
        element.style.color = this.color;
        element.classList.add('active');
      } else {
        element.style.color = '';
        element.classList.remove('active');
      }
    });
  }
}

customElements.define('collection-special', CollectionSpecial);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
class LookBooks extends HTMLElement {
  constructor() {
    super();

    this.selectorContent = this.querySelector('.lookbooks__content');
    this.selectorItems = this.querySelector('.lookbooks__items');

    this.closeButtons = this.querySelectorAll('.js-lookbooks-toggle');
    this.openButtons = this.querySelectorAll('.lookbooks__item-point');

    if (this.selectorContent && this.selectorItems) {
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', this.onClose.bind(this));
      });

      this.openButtons.forEach((button) => {
        button.addEventListener('click', this.onOpen.bind(this));
      });

      window.addEventListener('resize', debounce(() => {
        if (window.innerWidth > 991) {
          this.selectorContent.classList.remove('open', 'active');
          this.classList.remove('active');
          this.destroyCarousel();
        }
      }, 500));
    }
  }

  onOpen(e) {
    e.preventDefault();
    if (window.innerWidth < 992) {
      const index = e.currentTarget.dataset.index;
      this.classList.add('active');
      this.buildCarousel(index);

      setTimeout(() => {
        this.selectorContent.classList.add('active', 'open');
      }, 300);
    }
  }

  onClose(e) {
    e.preventDefault();
    if (window.innerWidth < 992) {
      this.selectorContent.classList.remove('open');

      setTimeout(() => {
        this.selectorContent.classList.remove('active');
        this.classList.remove('active');
        this.destroyCarousel();
      }, 500);
    }
  }

  buildCarousel(index) {
    if (!this.selectorItems.classList.contains('slick-initialized')) {
      $(this.selectorItems).slick({
        rows: 0,
        infinite: false
      }).slick('slickGoTo', index, true);
    } else {
      $(this.selectorItems).slickGoTo(index, true);
    }
  }

  destroyCarousel() {
    if (this.selectorItems.classList.contains('slick-initialized')) {
      $(this.selectorItems).slick('unslick');

      const lookbooksItems = this.querySelectorAll('.lookbooks__item');
      lookbooksItems.forEach((item) => {
        item.setAttribute('style', item.dataset.style);
      });
    }
  }
}

customElements.define('look-books', LookBooks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-simple"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-style1"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-load-more"] && !Shopify.designMode) return;
  try {
    

class ProductLoadmore extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.product-loadmore__btn');
    this.content = this.querySelector('.product-loadmore__items');

    if (this.button && this.content) {
      this.button.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(e) {
    e.preventDefault();
    const button = e.currentTarget;
    if (!e.currentTarget.classList.contains('disabled')) {
      button.classList.add('loading');
      const url = `${button.dataset.next}&section_id=${button.dataset.section}`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const products = html.querySelector('.product-loadmore__items');
          const responseButton = html.querySelector('.product-loadmore__btn');
          if (products) {
            this.content.innerHTML += products.innerHTML;
          }
          if (responseButton) {
            button.className = responseButton.className;
            button.dataset.next = responseButton.dataset.next || '';
          }
          button.classList.remove('loading');
        })
        .catch((e) => {
          console.error(e);
          button.classList.remove('loading');
        });
    }
  }
}

customElements.define('product-loadmore', ProductLoadmore);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        vela.swatchProduct();

                        // Update wishlist button status
                        if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                            vela.wishlist.updateWishlist();
                        }

                        $('body').trigger('carousel:init', '.js-recommendations');
                        $('body').trigger('vela:countdown', '[data-countdown]');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }
        
            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }
    customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewed"] && !Shopify.designMode) return;
  try {
    
    var vela = window.vela || {};
    vela.recentlyViewed = {
        name: 'vela_recently_viewed',
        symbol: '|',
        maximumItems: 10,
        exists: 365,
        products: []
    };

    // Load product handle from cookie
    var cookieRecentlyViewed = vela.getCookie(vela.recentlyViewed.name);
    if (cookieRecentlyViewed !== '') {
        var products = cookieRecentlyViewed.split(vela.recentlyViewed.symbol);
        products.forEach(function(item) {
            vela.recentlyViewed.products.push(item);
        });
    }

    // Add product handle to cookie.
    var pathname = window.location.pathname;
    if (vela && pathname.indexOf('/products/') !== -1) {
        var productHandle = pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var currentIndex = vela.recentlyViewed.products.indexOf(productHandle);
        if (currentIndex === -1) {
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
            // Only take vela.recentlyViewed.maximumItems items
            vela.recentlyViewed.products = vela.recentlyViewed.products.splice(0, vela.recentlyViewed.maximumItems);
        } else {
            // Remove current handle from array
            vela.recentlyViewed.products.splice(currentIndex, 1);
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
        }

        // Set cookie
        if (vela.recentlyViewed.products.length > 0) {
            var productHandles = vela.recentlyViewed.products.join(vela.recentlyViewed.symbol);
            vela.setCookie(vela.recentlyViewed.name, productHandles, vela.recentlyViewed.exists);
        }
    }

    class ProductRecentlyViewed extends HTMLElement {
        constructor() {
            super();

            this.hiddenClass = 'd-none';
            this.container = this.querySelector('[data-products]');
            this.limit = parseInt(this.dataset.limit, 10);

            if (this.container) {
                this.layout = this.container.dataset.products;

                document.addEventListener("DOMContentLoaded", (event) => {
                    this.initPages();
                });
            }
        }

        initPages() {
            if (vela && vela.recentlyViewed && vela.recentlyViewed.products) {
                if (vela.recentlyViewed.products.length > 1) {
                    this.renderPages();
                } else {
                    this.classList.add(this.hiddenClass);
                }
            } else {
                this.classList.add(this.hiddenClass);
            }
        }

        async renderPages() {
            try {
                let promises = [];
                vela.recentlyViewed.products.forEach((handle, index) => {
                    if (handle && index !== 0 && index <= this.limit) {
                        const url = `${window.Shopify.routes.root}products/${handle}?view=product-card`;
                        promises.push(
                            fetch(url)
                                .then(response => {
                                    if (!response.ok) {
                                        return '';
                                    }
                                    return response.text();
                                })
                                .then(text => {
                                    if (text && text !== '') {
                                        let productItem = document.createElement('div');
                                        const productItemClass = this.layout === 'grid' ? 'col' : 'slick-carousel__item';
                                        productItem.classList.add(productItemClass);
                                        productItem.innerHTML = text;

                                        return {
                                            error: false,
                                            element: productItem,
                                            handle: handle,
                                            index: index
                                        };
                                    }
                                    return {
                                        error: true,
                                        element: null,
                                        handle: handle,
                                        index: index
                                    };
                                })
                                .catch(e => {
                                    console.error(e);
                                    return {
                                        error: true,
                                        element: null,
                                        handle: handle,
                                        index: index
                                    };
                                })
                        );
                    }
                });

                let data = await Promise.all(promises);
                data.forEach(item => {
                    if (item.error) {
                        const index = vela.recentlyViewed.products.indexOf(item.handle);
                        if (index !== -1) {
                            vela.recentlyViewed.products.splice(index, 1);
                        }
                    } else if (item.element) {
                        this.container.append(item.element);
                    }
                });
                this.afterRenderPage();
            } catch (e) {
                console.error(e);
            };
        }

        afterRenderPage() {
            vela.setCookie(vela.recentlyViewed.name, vela.recentlyViewed.products.join(vela.recentlyViewed.symbol), vela.recentlyViewed.exists);
            this.classList.remove(this.hiddenClass);
            vela.swatchProduct();

            // Update wishlist button status
            if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                vela.wishlist.updateWishlist();
            }

            if (this.layout === 'carousel') {
                $('body').trigger('carousel:init', '.js-recently-viewed');
            }
            $('body').trigger('vela:countdown', '[data-countdown]');
        }
    }
    customElements.define('product-recently-viewed', ProductRecentlyViewed);

  } catch(e) { console.error(e); }
})();
})();
